import React, { 
  //useRef,
  useState, 
  useEffect 
} from 'react';
//import AnchorLink from 'react-anchor-link-smooth-scroll-v2'
import { Link } from "gatsby"
import { 
  //GatsbyImage, 
  //getImage, 
  getSrc 
} from "gatsby-plugin-image"
import {
  Menu,
  Image,
} from 'semantic-ui-react';

const svg_tritonLogo = (fillColor) => {
  /* const style = `
    .st0{fill:`+ fillColor +`;}
  `; */
  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
	y="0px" viewBox="0 0 558 232.5" style={{ enableBackground: 'new 0 0 558 232.5' }} xmlSpace="preserve">
      <g>
        <path style={{ fill:'#242052' }} d="M103.3,194.9c5,11.8-0.5,20.4-8.5,20.4c-3,0-15.7-3-24.5-7.6c-5.2-2.7-11.1-5.6-18-10.8
            c-6.4-5.3-10.7-8.8-17.7-17.3c-5.7-7.6-6.5-8.8-10.4-15.8c-1.5-3.1-3.6-7.3-4.9-10.5c-3.1-8.8-3.8-10.7-5.7-19.9
            c-1.2-8.6-1.5-11-1.5-21.4c0.7-8.6,0.8-10.1,2.5-18c0.8-2.8,0.7-2.4,1-3.5c-0.9,3.4-2.6,12.3,3.2,21.5c4.2,6.6,7.9,15.5,31.7,35.3
            C68.7,162.3,96.3,178.3,103.3,194.9"></path>
        <g>
          <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="12.023" y1="147.2741" x2="94.7808" y2="147.2741">
            <stop offset="0" style={{ stopColor: '#2BC4F3' }}></stop>
            <stop offset="0.5" style={{ stopColor: '#00AEEE' }}></stop>
            <stop offset="1" style={{ stopColor: '#0095DA' }}></stop>
          </linearGradient>
          <path style={{opacity: '0.9', fill:'url(#SVGID_1_)'}} d="M57.7,152.9c1.4,8.5,3.5,17.5,7.3,28.6c1.8,5.2,3.9,9.9,6.3,14.1
                c6.8,12,13.8,18.2,23.1,19.6l0.5,0.1c-3,0-15.7-3-24.5-7.6c-5.2-2.7-11.1-5.6-18-10.8c-6.4-5.3-10.7-8.8-17.7-17.3
                c-5.7-7.6-6.5-8.8-10.4-15.8c-1.5-3.1-3.6-7.3-4.9-10.5c-3.1-8.8-3.8-10.7-5.7-19.9c-1.2-8.6-1.5-11-1.5-21.4
                c0.7-8.6,0.8-10.1,2.5-18c0.8-2.8,0.7-2.4,1-3.5l0,0c3-10,12-13.3,18.8-9.6c3.2,1.8,6.2,5.2,8.8,9.7c2.8,4.9,5.2,11.1,6.9,17.8
                C54.5,126.3,55.3,138.8,57.7,152.9"></path>
        </g>
        <path style={{ fill: '#242052' }} d="M186.4,86.8c7.8-10.2,17.9-9.8,21.9-2.8c1.5,2.6,5.2,15.1,5.7,25c0.3,5.8,0.7,12.4-0.4,21
            c-1.4,8.2-2.3,13.6-6.1,24c-3.8,8.7-4.4,10-8.5,16.9c-2,2.9-4.6,6.7-6.7,9.5c-6.1,7.1-7.3,8.6-14.4,14.8
            c-6.9,5.4-8.7,6.8-17.8,11.9c-7.8,3.7-9.2,4.3-16.9,6.8c-2.8,0.7-2.4,0.6-3.5,0.9c3.4-0.9,12-3.8,17-13.5c3.6-7,9.5-14.6,14.8-45.1
            C175.4,133.1,175.5,101.2,186.4,86.8"></path>
        <g>
          <path style={{ opacity: '0.9', fill: '#00599C' }} d="M172.8,147.3c6.6-5.5,13.4-11.7,21.2-20.6c3.6-4.2,6.6-8.3,9.1-12.4
                c7-11.8,8.9-21,5.5-29.8l-0.2-0.5c1.5,2.6,5.2,15.1,5.7,25.1c0.3,5.8,0.7,12.4-0.4,21c-1.4,8.2-2.3,13.6-6.1,24
                c-3.8,8.7-4.4,10-8.5,16.9c-2,2.9-4.6,6.7-6.7,9.5c-6.1,7.1-7.3,8.6-14.4,14.8c-6.9,5.4-8.7,6.8-17.8,11.9
                c-7.8,3.7-9.2,4.3-16.9,6.8c-2.8,0.7-2.4,0.6-3.5,0.9l0,0c-10.2,2.4-17.6-3.8-17.7-11.5c-0.1-3.7,1.4-8,4-12.5
                c2.8-4.9,7-10,12-14.9C151.2,163.3,161.7,156.4,172.8,147.3"></path>
        </g>
        <path style={{ fill: '#242052' }} d="M50.6,70.6C37.8,69.1,33.1,60.2,37,53.2c1.5-2.6,10.3-12.1,18.7-17.6C60.5,32.3,66,28.7,74,25.2
            c7.8-3,12.9-5,23.7-6.9c9.4-1.2,10.9-1.3,18.9-1.3c3.5,0.2,8.1,0.5,11.6,0.9c9.2,1.6,11.1,1.9,20.1,4.8c8.1,3.2,10.3,4.1,19.4,9.3
            c7.1,4.8,8.4,5.7,14.5,11.1c2.1,2.1,1.7,1.8,2.6,2.6c-2.5-2.5-9.4-8.4-20.3-7.8c-7.8,0.4-17.4-0.8-46.4,10.2
            C96,56.6,68.5,72.7,50.6,70.6"></path>
        <g style={{ opacity: '0.9' }}>
          <path style={{ opacity: '0.9', fill: '#74CCE5' }} d="M109.5,51.6c-8.1-2.9-16.9-5.6-28.5-7.8c-5.4-1-10.5-1.5-15.3-1.5
                c-13.8,0-22.6,3-28.4,10.4L37,53.2c1.5-2.6,10.4-12.1,18.7-17.6C60.5,32.3,66,28.7,74,25.2c7.8-3,12.9-5,23.7-6.9
                c9.4-1.2,10.9-1.3,18.9-1.3c3.5,0.2,8.1,0.5,11.6,0.9c9.2,1.6,11.1,1.9,20.1,4.8c8.1,3.2,10.3,4.1,19.4,9.3
                c7.1,4.8,8.4,5.7,14.5,11.1c2.1,2.1,1.7,1.8,2.6,2.6l0,0c7.3,7.6,5.7,17.1-0.9,21.1c-3.2,1.9-7.6,2.8-12.8,2.9
                c-5.6,0-12.2-1-18.9-2.8C134.3,62,123,56.5,109.5,51.6"></path>
        </g>
        <g>
          <path style={{ fill: '#43A9E0' }} d="M262.4,162.8c0-0.4,0.3-0.7,0.7-0.7h3.5c3.7,0,6.3,2.6,6.3,5.9v0c0,3.3-2.6,5.9-6.3,5.9H263
                c-0.4,0-0.7-0.3-0.7-0.7V162.8z M266.5,172.8c3,0,4.9-2,4.9-4.7v0c0-2.6-1.9-4.7-4.9-4.7h-2.8v9.4H266.5z">
          </path>
          <path style={{ fill: '#43A9E0' }} d="M309.6,162.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v10.7c0,0.4-0.3,0.7-0.7,0.7
                c-0.4,0-0.7-0.3-0.7-0.7V162.7z"></path>
          <path style={{ fill: '#43A9E0' }} d="M347.8,168.1L347.8,168.1c0-3.3,2.4-6.2,5.9-6.2c1.8,0,3,0.5,4,1.3c0.2,0.1,0.3,0.3,0.3,0.5
                c0,0.4-0.3,0.7-0.7,0.7c-0.2,0-0.3-0.1-0.4-0.2c-0.8-0.6-1.8-1.1-3.3-1.1c-2.6,0-4.5,2.2-4.5,4.9v0c0,2.8,1.8,4.9,4.7,4.9
                c1.4,0,2.6-0.5,3.4-1.2v-2.9h-3.2c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h3.8c0.4,0,0.7,0.3,0.7,0.7v3.6
                c0,0.3-0.2,0.6-0.5,0.8c-1.1,0.8-2.5,1.4-4.3,1.4C350.1,174.2,347.8,171.5,347.8,168.1z"></path>
          <path style={{ fill: '#43A9E0' }} d="M395.6,162.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v10.7c0,0.4-0.3,0.7-0.7,0.7
                c-0.4,0-0.7-0.3-0.7-0.7V162.7z"></path>
          <path style={{ fill: '#43A9E0' }} d="M437.4,163.4H434c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h8.2c0.3,0,0.6,0.3,0.6,0.6
                c0,0.3-0.3,0.6-0.6,0.6h-3.4v10c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7V163.4z"></path>
          <path style={{ fill: '#43A9E0' }} d="M477,173.1l4.8-10.5c0.2-0.4,0.4-0.6,0.8-0.6h0.1c0.4,0,0.7,0.2,0.8,0.6l4.8,10.5
                c0.1,0.1,0.1,0.2,0.1,0.3c0,0.4-0.3,0.6-0.6,0.6c-0.3,0-0.5-0.2-0.7-0.5l-1.2-2.7h-6.5l-1.2,2.8c-0.1,0.3-0.3,0.5-0.6,0.5
                c-0.3,0-0.6-0.3-0.6-0.6C476.9,173.4,476.9,173.2,477,173.1z M485.4,169.6l-2.7-6.1l-2.7,6.1H485.4z"></path>
          <path style={{ fill: '#43A9E0' }} d="M524.9,162.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v10h6.1c0.3,0,0.6,0.3,0.6,0.6
                c0,0.3-0.3,0.6-0.6,0.6h-6.8c-0.4,0-0.7-0.3-0.7-0.7V162.7z"></path>
        </g>
        <path style={{ fill: '#242052' }} d="M537.9,84v-4.7h-1.7v-0.8h4.1v0.8h-1.7V84H537.9z M541.8,80.1l1.4,2.1h0.4l1.4-2.1V84h0.8v-5.5h-0.6
            l-1.8,2.7l-1.8-2.7H541V84h0.8V80.1z M290,78.4h-43.7v11.8h15.3v61.7h13.1V90.2H290V78.4z M345.7,151.9l-16.2-28.1
            c8.9-2.9,12.8-8.8,12.8-19.7v-3.8c0-15.6-8.3-22.1-26.2-22.1h-18.6v73.7h13.2v-26h4.9l14.7,26H345.7z M310.6,113.7V90.3h5.7
            c10.3,0,12.1,3.6,12.1,10.6v2.5c0,7-2.7,10.3-12.3,10.3H310.6z M367.8,78.2h-13.3v73.7h13.3V78.2z M419,78.4h-43.7v11.8h15.3v61.7
            h13.1V90.2H419V78.4z M447.7,152.5c17.5,0,25.2-6.8,25.2-22V99.3c0-15.6-7.4-22-25.2-22c-17.8,0-24.6,6.4-24.6,22v31.2
            C423,145.7,430.1,152.5,447.7,152.5z M447.7,140.8c-9.6,0-11.4-4-11.4-11V100c0-6.7,1.8-11,11.4-11c10.3,0,12,4.3,12,11v29.9
            C459.6,136.8,457.2,140.8,447.7,140.8z M531.9,78.2h-13.1v17.4l1.4,31.1l-21.7-48.6h-13.1v73.6h13.1v-18.8l-1.1-28l21.7,46.7h12.8
            V78.2z"></path>
      </g>
    </svg>
)};

export default function NavItemLogo(props) {
  //console.log('NavItemLogo - props', props);

  const { image } = props;

  const [navItemLogoState, setNavItemLogoState] = useState({
    imageAltText: 'Triton Digital',
    logoImageType: null,
    gatsbyImageDataGetSrc: null,
  });

  useEffect(() => {
    if (navItemLogoState.logoImageType === null) {
      //console.debug('NavItemLogo - useEffect');
      let initLogoImageType = 'default';
      let gatsbyImageDataGetSrc = null;
      if (image) {
        if (image.gatsbyImageData) {
          initLogoImageType = 'gatsbyImageData';
          gatsbyImageDataGetSrc = getSrc(image.gatsbyImageData);
        } else if (image.imageAbsoluteUrls && image.imageAbsoluteUrls.length !== 0) {
          initLogoImageType = 'imageAbsoluteUrls'
        }
      }
      setNavItemLogoState({
        ...navItemLogoState,
        logoImageType: initLogoImageType,
        gatsbyImageDataGetSrc
      })
    }
  }, [image, navItemLogoState]);
  //console.debug('NavItemLogo - navItemLogoState', navItemLogoState);
  return (
    <>
      {(() => {
        switch(props.pageArea) {
          case 'mobile-sidebar-nav':
            return (
              <Menu.Item key={props.id} className={'brand-logo'} aria-label={'Home'}>
                {navItemLogoState.logoImageType !== 'default' ?
                  (navItemLogoState.logoImageType === 'gatsbyImageData' ?
                    <>
                      <Image fluid src={navItemLogoState.gatsbyImageDataGetSrc} alt={navItemLogoState.imageAltText} />
                      {/* <GatsbyImage loading={'eager'} image={getImage(props.image.gatsbyImageData)} alt={imageAltText} /> */}
                    </>
                  : navItemLogoState.logoImageType === 'imageAbsoluteUrls' ?
                    <Image fluid src={props.image.imageAbsoluteUrls[0]} alt={navItemLogoState.imageAltText} />
                  :
                    svg_tritonLogo(props.header_text_color ? props.header_text_color : 'grey')
                  )
                :
                  svg_tritonLogo(props.header_text_color ? props.header_text_color : 'grey')
                }
              </Menu.Item>
            );
          case 'main-nav-container':
            return (
              <Menu.Item key={props.id} 
                //as={AnchorLink}
                //href={'/'+props.dOMID}
                //offset='80'
                as={Link}
                to={'/'}
                className={'brand-logo'} aria-label={'Home'}
              >
                {navItemLogoState.logoImageType !== 'default' ?
                  (navItemLogoState.logoImageType === 'gatsbyImageData' ?
                    <>
                      <Image fluid src={navItemLogoState.gatsbyImageDataGetSrc} alt={navItemLogoState.imageAltText} />
                      {/* <GatsbyImage loading={'eager'} image={getImage(props.image.gatsbyImageData)} alt={imageAltText} /> */}
                    </>
                  : navItemLogoState.logoImageType === 'imageAbsoluteUrls' ?
                    <Image fluid src={props.image.imageAbsoluteUrls[0]} alt={navItemLogoState.imageAltText} />
                  :
                    svg_tritonLogo(props.header_text_color ? props.header_text_color : 'grey')
                  )
                :
                  svg_tritonLogo(props.header_text_color ? props.header_text_color : 'grey')
                }
              </Menu.Item>
            );
          case 'mobile-main-nav':
            return (
              <Menu.Item key={props.id} as={Link}
                to={'/'}
                className={'brand-logo'} aria-label={'Home'}
              >
                {navItemLogoState.logoImageType !== 'default' ?
                  (navItemLogoState.logoImageType === 'gatsbyImageData' ?
                    <>
                      <Image fluid src={navItemLogoState.gatsbyImageDataGetSrc} alt={navItemLogoState.imageAltText} />
                      {/* <GatsbyImage loading={'eager'} image={getImage(props.image.gatsbyImageData)} alt={imageAltText} /> */}
                    </>
                  : navItemLogoState.logoImageType === 'imageAbsoluteUrls' ?
                    <Image fluid src={props.image.imageAbsoluteUrls[0]} alt={navItemLogoState.imageAltText} />
                  :
                    svg_tritonLogo(props.header_text_color ? props.header_text_color : 'grey')
                  )
                :
                  svg_tritonLogo(props.header_text_color ? props.header_text_color : 'grey')
                }
              </Menu.Item>
            );
          default:
            return null;
        }
      })()}
    </>
  )
}